import { render } from "./PdfViewer.vue?vue&type=template&id=7a6de74e&scoped=true&ts=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"

import "./PdfViewer.vue?vue&type=style&index=0&id=7a6de74e&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6de74e"],['__file',"src/components/PdfViewer/PdfViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a6de74e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a6de74e', __exports__)) {
    console.log('reload')
    api.reload('7a6de74e', __exports__)
  }
  
  module.hot.accept("./PdfViewer.vue?vue&type=template&id=7a6de74e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7a6de74e', render)
  })

}


export default __exports__